"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeArrays = mergeArrays;
const api_delete_js_1 = require("../dtos/api-delete.js");
function mergeArrays(existing, input, mergeFn) {
    if (!input) {
        return existing;
    }
    if (input.set) {
        return input.set;
    }
    const result = [...existing];
    if (input.upsert) {
        for (const incoming of input.upsert) {
            const existingIndex = result.findIndex((item) => item.id === incoming.id);
            if (incoming.data === api_delete_js_1.API_DELETE && existingIndex !== -1) {
                result.splice(existingIndex, 1);
            }
            else if (existingIndex === -1 && incoming.data !== api_delete_js_1.API_DELETE) {
                result.push(incoming.data);
            }
            else if (incoming.data !== api_delete_js_1.API_DELETE) {
                result[existingIndex] = incoming.data;
            }
        }
    }
    if (input.update) {
        for (const incoming of input.update) {
            const existingIndex = result.findIndex((item) => item.id === incoming.id);
            if (existingIndex === -1) {
                continue;
            }
            if (incoming.data === api_delete_js_1.API_DELETE) {
                result.splice(existingIndex, 1);
            }
            else {
                const existingItem = result[existingIndex];
                result[existingIndex] = mergeFn(existingItem, incoming.data);
            }
        }
    }
    if (input.create) {
        input.create.forEach((incoming) => {
            if (result.find((item) => item.id === incoming.id)) {
                return;
            }
            result.push(incoming);
        });
    }
    return result;
}
//# sourceMappingURL=merge-arrays.js.map